var map = {
	"./AG.png": 307,
	"./AI.png": 2589,
	"./AR.png": 8414,
	"./BE.png": 5036,
	"./BL.png": 3853,
	"./BS.png": 4410,
	"./CH.png": 3758,
	"./FR.png": 6727,
	"./GE.png": 6743,
	"./GL.png": 3686,
	"./GR.png": 6200,
	"./JU.png": 5124,
	"./LU.png": 3550,
	"./NE.png": 4976,
	"./NW.png": 6802,
	"./OW.png": 7101,
	"./SG.png": 5497,
	"./SH.png": 6606,
	"./SO.png": 2721,
	"./SW.png": 9657,
	"./SZ.png": 5212,
	"./TA_DZK.png": 5006,
	"./TA_SST.png": 3525,
	"./TG.png": 2052,
	"./TI.png": 2762,
	"./UR.png": 4418,
	"./VD.png": 9153,
	"./VS.png": 2830,
	"./ZG.png": 8678,
	"./ZH.png": 8481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3358;